<template>
    <div class="firdar-table">
        <div class="firdar-table-title">Таблица Фирдаров</div>

        <div class="firdar-row-wrapper"
             v-for="bigFirdar in firdarFormattedData">
            <div class="firdar-btn"
                 :class="{'active' : planetCollapsed(bigFirdar.planet)}"
                 @click="collapseFirdar(bigFirdar.planet)"
                 v-if="bigFirdar.smallFirdars.length > 0"/>
            <div class="firdar-row">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="firdar-planet">
                    <PlanetIcon x="0" y="0" :planet="bigFirdar.planet"/>
                </svg>
                <div class="firdar-date">{{ bigFirdar.startDate }} - {{ bigFirdar.endDate }}</div>
            </div>
            <div class="firdar-row-sub"
                 :class="{'active' : planetCollapsed(bigFirdar.planet)}"
                 v-if="bigFirdar.smallFirdars.length > 0">
                <div class="firdar-row"
                     v-for="smallFirdar in bigFirdar.smallFirdars">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="firdar-planet">
                        <PlanetIcon x="0" y="0" :planet="bigFirdar.planet"/>
                    </svg>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="firdar-planet">
                        <PlanetIcon x="0" y="0" :planet="smallFirdar.planet"/>
                    </svg>
                    <div class="firdar-date">{{ smallFirdar.startDate }} - {{ smallFirdar.endDate }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';
    import PlanetIcon from '@/components/icon/PlanetIcon';

    export default {
        name: 'FirdarTable',

        props: ['firdarData', 'timezoneId'],

        components: {
            PlanetIcon
        },

        data() {
            return {
                collapsedPlanets: []
            }
        },

        computed: {
            firdarFormattedData() {
                if (!this.firdarData || this.firdarData.length == 0)
                    return [];

                return this.firdarData.map(bigFirdar => {
                    return {
                        planet: bigFirdar.planet,
                        smallFirdars: bigFirdar.smallFirdars ? bigFirdar.smallFirdars.map(smallFirdar => {
                            return {
                                planet: smallFirdar.planet,
                                startDate: this.formatDate(smallFirdar.startDate),
                                endDate: this.formatDate(smallFirdar.endDate)
                            };
                        }) : [],
                        startDate: this.formatDate(bigFirdar.startDate),
                        endDate: this.formatDate(bigFirdar.endDate)
                    };
                });
            }
        },

        methods: {
            formatDate(date) {
                return moment.tz(new Date(date), this.timezoneId).format("DD-MM-YYYY HH:mm");
            },

            planetCollapsed(planet) {
                return this.collapsedPlanets.includes(planet);
            },

            collapseFirdar(planet) {
                if (this.planetCollapsed(planet))
                    this.collapsedPlanets = this.collapsedPlanets.filter(p => p !== planet);
                else
                    this.collapsedPlanets.push(planet);
            }
        }
    }
</script>